export const getAcronym = title => {
  let words = title
    .split(/ |\.|_|,/g)
    .map(word => word.trim())
    .filter(word => word.length > 0)

  if (words.length === 1) {
    return words[0].substring(0, 3).toUpperCase()
  } else if (words.length > 3) {
    words = words.filter(word => word.length > 3)
    const longerWords = words.filter(word => word.length > 3)
    if (longerWords.length > 1) {
      words = longerWords
    }
  } else if (words.length === 0) {
    words = ['N', 'A']
  }

  return words
    .map(word => word[0].toUpperCase())
    .join('')
    .substring(0, 3)
}

export const camelToTitle = string =>
  string
    .replace(/([A-Z]|[0-9]+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .replace(/\s+/g, ' ')

export const zeroFill = (input, length) => {
  const inputStr = String(input)

  if (inputStr.trim().length >= length) {
    return inputStr
  } else {
    return inputStr.padStart(length, '0')
  }
}

export const base64Encode = str =>
  btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
      String.fromCharCode(`0x${p1}`)
    )
  )

export const base64Decode = str =>
  decodeURIComponent(
    atob(str)
      .split('')
      .map(char => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  )



// WEBPACK FOOTER //
// ./src/helpers/transforms.js